import Lottie from 'lottie-react';

import emptyBoardCertifications from '../jsons/empty-board-certifications.json';

const EmptyBoardCertifications = props => {
  return <Lottie loop={false} animationData={emptyBoardCertifications} {...props} />;
};

export default EmptyBoardCertifications;
